import { FC } from "react";

export const Divider: FC = () => (
  <div className="w-full border-t border-gray-300 my-2" />
);
